var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer-------------------Start
function fontResizer() {
  var perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + "px";
}


let headerss = document.querySelector("header");

if (headerss) {
  function setNavigation() {
    let current_location = location.pathname.split("/")[1];
    if (current_location === "") return;
    let menu_items = document.querySelector("header").getElementsByTagName("a");
    for (let i = 0, len = menu_items.length; i < len; i++) {
      if (menu_items[i].getAttribute("href").indexOf(current_location) !== -1) {
        menu_items[i].classList.add("active");
      }
    }
  }
  setNavigation();
}

var acc = document.getElementsByClassName("toggle-btn");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].querySelector("p").addEventListener("click", function () {
    this.classList.toggle("opened");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    console.log("checking height", panel.style.maxHeight);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Loader-------------------Start
function pageLoader() {
  // document.querySelector("html").classList.add("loadjs");
  setTimeout(function () {
    document.querySelector(".loader-first").style.display = "none";
    document.querySelector("html").classList.remove("loadjs");
  }, 300);
}
if (sw < 1200) {
  let mobileToggle = document.querySelectorAll(".mobileToggle");

  for (let i = 0; i < mobileToggle.length; i++) {
    mobileToggle[i].addEventListener("click", (event) => {
      mobileToggle[i].classList.toggle("open--menu");
      mobileToggle[i].nextElementSibling.classList.toggle("openMegaMenu");
    });
  }
}

if (sw < 1200) {
  let mobileToggle2nd = document.querySelectorAll(".sub-mobileToggle");

  for (let i = 0; i < mobileToggle2nd.length; i++) {

    mobileToggle2nd[i].addEventListener("click", (event) => {
      mobileToggle2nd[i].classList.toggle("open--menu2nd");
      mobileToggle2nd[i].nextElementSibling.classList.toggle("openMegaMenu2nd");
    });
  }
}

if (sw < 1200) {
  let leadership = document.querySelectorAll(".js-cardWrapper");

  for (let i = 0; i < leadership.length; i++) {
    leadership[i].addEventListener("click", (event) => {
      leadership[i].classList.toggle("flip-card");
    });
  }
}

// document.querySelector('.search-btn').addEventListener('click', function (event) {
//   event.preventDefault();
//   var target = document.querySelector('header');
//   if (target.classList.contains('search-open')) {
//     target.classList.remove('search-open');
//   } else {
//     target.classList.add('search-open');
//   }
// });

// Navigation slide Active on a mobile
let toggleMenu = document.querySelector("#toggle");
let htmlEl = document.querySelector("html");

toggleMenu.addEventListener("click", (event) => {
  console.log("this", event);
  let _this = event.target;
  _this.classList.toggle("active");
  document.querySelector(".navigation").classList.toggle("open");
  htmlEl.classList.toggle("overflow-hidden");
});

// accordion
var accordion = document.getElementsByClassName("faqs__faq-accordion");
var j;

for (j = 0; j < accordion.length; j++) {
  accordion[j].querySelector("h4").addEventListener("click", function () {
    this.classList.toggle("opened");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    // console.log('checking height', panel.style.maxHeight)
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Landscape Mode off
function landscapeModeOff() {
  if (sh < 450 && sw > 480 && sw < 820) {
    document.getElementById("portrait-warnning").style.display = "flex";
  } else {
    document.getElementById("portrait-warnning").style.display = "none";
  }
}

// Sticky Header----------------Start
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

// SVG Convert Code
let svgs = document.querySelectorAll("img.svg-convert");
svgs.forEach((el) => {
  const imgID = el.getAttribute("id");
  const imgClass = el.getAttribute("class");
  const imgURL = el.getAttribute("src");

  fetch(imgURL)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, "text/html");
      let svg = xmlDoc.querySelector("svg");
      if (typeof imgID !== "undefined") {
        svg.setAttribute("id", imgID);
      }

      if (typeof imgClass !== "undefined") {
        svg.setAttribute("class", imgClass + " svg-converted");
      }

      svg.removeAttribute("xmlns:a");

      el.parentNode.replaceChild(svg, el);
    });
});

// Window on Load-----------------Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
};

// Window On Resize-----------------Start
window.addEventListener("resize", (event) => {
  sw = window.innerWidth;
  sh = window.innerHeight;
  landscapeModeOff();
  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) {} else {
      fontResizer();
    }
  }
});

// Window On Scroll-----------------Start
window.addEventListener("scroll", (event) => {
  stickyHeader();
});

const tabs = document.querySelectorAll("[data-tab-target]");
const tabContents = document.querySelectorAll("[data-tab-content]");

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    const target = document.querySelector(tab.dataset.tabTarget);
    tabContents.forEach((tabContent) => {
      tabContent.classList.remove("active");
    });
    tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
    tab.classList.add("active");
    target.classList.add("active");
  });
});

// emiritization slider
if (document.querySelector(".emiritization-slider__wrapper")) {
  var emiritization__swiper = new Swiper(".emiritization-slider__wrapper", {
    spaceBetween: 0,
    speed: 1500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
    },
  });
}

// custom select to
(function () {
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.addEventListener("click", function (e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      let heroformDropdown = document.querySelectorAll(
        ".hero-form__col:not(.hero-form__col--btnn) .hero-form__dropdown"
      );
      heroformDropdown.forEach(function (elmt) {
        elmt.classList.remove("active");
      });

      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
})();



//  Custome Input File Field for html
(function () {
  if (document.querySelector('.c_form-field')) {
    (function (document, window, index) {
      var inputs = document.querySelectorAll('.c_form-field:not(.inputFileField) .inputfile');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;

        input.addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
          input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
          input.classList.remove('has-focus');
        });
      });
    }(document, window, 0));
  }
})();


// for wordpress
(function () {
  if (document.querySelector('.c_form-field.inputFileField')) {
    (function (document, window, index) {
      var inputs = document.querySelectorAll('.inputFileField');
      Array.prototype.forEach.call(inputs, function (input) {

        var label = input.querySelector(".wpcf7-form-control-wrap").nextElementSibling,
          labelVal = label.innerHTML;
        input.querySelector(".wpcf7-form-control-wrap input").addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () {
          input.classList.add('has-focus');
        });
        input.addEventListener('blur', function () {
          input.classList.remove('has-focus');
        });
      });
    }(document, window, 0));
  }
})();

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})

//Home How It Works Thumb -------------- START
if (document.querySelector(".historyThumbSlider")) {
  var historyThumbSlider = new Swiper(".historyThumbSlider", {
    slidesPerView: 4,
    speed: 2000,
    loop: false,
    observer: true,
    observeParents: true,
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 6,
      },
      991: {
        slidesPerView: 6,
      },
      1199: {
        slidesPerView: 11,
      },
    },
  });
}
//Home How It Works Thumb --------------END

// Home Works Gallery Slider -------------- START
if (document.querySelector(".historyDetailSlider")) {
  var historyDetailSlider = new Swiper(".historyDetailSlider", {
    slidesPerView: 1,
    loop: false,
    speed: 2000,
    spaceBetween: 30,
    centeredSlides: true,
    draggable: true,
    effect: 'coverflow',
    observer: true,
    observeParents: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 0,
      slideShadows: false,
    },
    autoplay: {
      enable: true,
      delay: 2500,
      disableOnInteraction: true,
    },
    thumbs: {
      swiper: historyThumbSlider,
    },
    navigation: {
      nextEl: ".historySlider-wrapper .swiper-button-next",
      prevEl: ".historySlider-wrapper .swiper-button-prev",
    },
    breakpoints: {
      576: {
        spaceBetween: 50,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 40,
          depth: 400,
          modifier: 1,
          slideShadows: false,
        },
      },
      1199: {
        spaceBetween: 100,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 150,
          depth: 300,
          modifier: 1,
          slideShadows: false,
        },
      },
      1400: {
        spaceBetween: 300,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 197,
          depth: 400,
          modifier: 1,
          slideShadows: false,
        },
      },
    },
  });
}
//Home Works Gallery Slider------------------------------ END


// Policy slider
if (document.querySelector(".policies-slider")) {
  var policySlider = new Swiper(".policies-slider", {
    slidesPerView: 1,
    loop: false,
    speed: 2000,
    allowTouchMove: true,
    autoplay: {
      enable: true,
      delay: 2500,
      disableOnInteraction: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });
}

// Agreement slider
if (document.querySelector(".agreement-slider")) {
  var agreementSlider = new Swiper(".agreement-slider", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".agreement-slider .swiper-button-next",
      prevEl: ".agreement-slider .swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 5.8,
        spaceBetween: 30,
      },
    },
  });
}

// Agreement slider
if (document.querySelector(".awards-slider")) {
  var awardsSlider = new Swiper(".awards-slider", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".awards-slider .swiper-button-next",
      prevEl: ".awards-slider .swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 4.8,
      },
    },
  });
}

var progress = document.querySelector('.qhse-dashboard .right-wrapper');
if (progress) {
  var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  window.addEventListener('scroll', function (event) {
    if (isInViewport(progress)) {

      const counters = document.querySelectorAll(".qhse-wrapper:not(.counter-complete) .counter");

      if (counters) {
        counters.forEach((counter) => {
          counter.innerText = "0";

          const updateCounter = () => {
            const target = +counter.getAttribute("data-target");
            const c = +counter.innerText;

            const increment = target / 1000;
            console.log(increment);

            if (c < target) {
              counter.innerText = `${Math.ceil(c + increment)}`;
              setTimeout(updateCounter, 1);
            } else {
              counter.innerText = target;
            }
            const factual_results = document.querySelectorAll(".qhse-wrapper");
            factual_results[0].classList.add('counter-complete')
          };

          updateCounter();
        });
      }
    }
  });
}

var downstream__center__swiper;
var downstream__thumbswiper;

if (document.querySelector(".downstream-solution__main-sliders-wrapper")) {

  downstream__center__swiper = new Swiper(".downstream-solution__center-slider .swiper ", {
    spaceBetween: 0,
    slidesPerView: 1,
    effect: "fade",
    allowTouchMove: false,
    watchSlidesProgress: true,
  });

  console.log(downstream__center__swiper)

  if(downstream__center__swiper.slides.length == 2) {
    downstream__center__swiper.hostEl.closest(".downstream-solution__center-slider").classList.add("downstream-solution__center-slider--two");
  }

  if(downstream__center__swiper.slides.length == 3 ) {
    downstream__center__swiper.hostEl.closest(".downstream-solution__center-slider").classList.add("downstream-solution__center-slider--three");
  }

  if(downstream__center__swiper.slides.length == 4) {
    downstream__center__swiper.hostEl.closest(".downstream-solution__center-slider").classList.add("downstream-solution__center-slider--four");
  }

  if(downstream__center__swiper.slides.length == 6) {
    downstream__center__swiper.hostEl.closest(".downstream-solution__center-slider").classList.add("downstream-solution__center-slider--six");
  }



  downstream__center__swiper.on('slideChange', function () {
    let redDot = document.querySelector(".red-dot");

    // console.log(downstream__center__swiper.activeIndex)
    // console.log(downstream__center__swiper.slides[0])
    // let currentIndex = downstream__center__swiper.activeIndex;
    // console.log(this.slides[currentIndex])

    // console.log(this.slides.length === 4 )

    // for two dots
    if (this.slides.length === 2) {
      if (sw < 768) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "-0.5em";
          redDot.style.top = "4em";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 1.5em)";
          redDot.style.top = "4em";
        }
      }

      if (sw > 767) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0";
          redDot.style.top = "8em";

        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "8em";
        }
      }
    }

    // for three dots
    if (this.slides.length === 3) {
      if (sw < 768) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "18%";
          redDot.style.left = "0.5em";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(25%)";
          redDot.style.margin = "0";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2.5em)";
          redDot.style.top = "18%";
          redDot.style.transform = "translateX(-25%)";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "calc(100% - 0.9375em)";
          redDot.style.right = "0em";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";
        }

      }

      if (sw > 767) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "8em";
          redDot.style.left = "0";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(25%)";
          redDot.style.margin = "0";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "8em";
          redDot.style.transform = "translateX(-25%)";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "calc(100% - 0.9375em)";
          redDot.style.right = "0em";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";


        }



      }
    }


    // for four dots
    if (this.slides.length === 4) {

      if (sw < 768) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0.5em";
          redDot.style.top = "18%";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2.5em)";
          redDot.style.top = "18%";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "-0.5em";
          redDot.style.top = "70%";
        }

        if (this.slides[3].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 1.5em)";
          redDot.style.top = "70%";
        }


      }

      if (sw > 767) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0.5em";
          redDot.style.top = "8em";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "8em";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0em";
          redDot.style.top = "26em";
        }

        if (this.slides[3].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "26em";
        }

      }
    }

    // for six dots
    if (this.slides.length === 6) {

      if (sw < 768) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0";
          redDot.style.top = "18%";
          redDot.style.transform = "translateX(0)";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "-0.9375em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "18%";

        }

        if (this.slides[3].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0em";
          redDot.style.top = "70%";
          redDot.style.transform = "translateX(0)";
        }

        if (this.slides[4].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "calc(100% - 0.9375em)";
          redDot.style.right = "0em";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";

        }

        if (this.slides[5].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "70%";
          redDot.style.transform = "translateX(0)";

        }


      }

      if (sw > 767) {
        if (this.slides[0].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0";
          redDot.style.top = "8em";
          redDot.style.transform = "translateX(0)";
        }

        if (this.slides[1].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "-0.9375em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";
        }

        if (this.slides[2].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "8em";

        }

        if (this.slides[3].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "0em";
          redDot.style.top = "26em";
          redDot.style.transform = "translateX(0)";
        }

        if (this.slides[4].classList.contains("swiper-slide-visible")) {
          redDot.style.top = "calc(100% - 0.9375em)";
          redDot.style.right = "0em";
          redDot.style.bottom = "0em";
          redDot.style.transform = "translateX(-50%)";
          redDot.style.left = "50%";

        }

        if (this.slides[5].classList.contains("swiper-slide-visible")) {
          redDot.style.left = "calc(100% - 2em)";
          redDot.style.top = "26em";
          redDot.style.transform = "translateX(0)";

        }

      }
    }
  });

  downstream__thumbswiper = new Swiper(".downstream-solution__thumb-slider .swiper ", {
    spaceBetween: 0,
    slidesPerView: "auto",
    freeMode: false,
    watchSlidesProgress: true,
    allowTouchMove: true,
    touchRatio: 1
  });

  if(downstream__thumbswiper.slides.length == 2) {
    downstream__thumbswiper.hostEl.closest(".downstream-solution__thumb-slider").classList.add("downstream-solution__thumb-slider--two");
  }

  if(downstream__thumbswiper.slides.length == 3) {
    downstream__thumbswiper.hostEl.closest(".downstream-solution__thumb-slider").classList.add("downstream-solution__thumb-slider--three");
  }

  if(downstream__thumbswiper.slides.length == 4) {
    downstream__thumbswiper.hostEl.closest(".downstream-solution__thumb-slider").classList.add("downstream-solution__thumb-slider--four");
  }

  if(downstream__thumbswiper.slides.length == 6) {
    downstream__thumbswiper.hostEl.closest(".downstream-solution__thumb-slider").classList.add("downstream-solution__thumb-slider--six");
  }




  var downstream__text__swiper = new Swiper(".downstream-solution__text-slider .swiper", {
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 1000,
    effect: "fade",
    thumbs: {
      swiper: downstream__thumbswiper,
    },
    on: {
      init: function () {
        let slideIndex;
        let id = (window.location.hash);
        if (id) {
          this.slides.forEach((slide, i) => {
            if (slide.getAttribute('data-rid') == id.replace("#", "")) {
              slideIndex = i;
            }
          })
        }
        setTimeout(() => {
          this.slideTo(slideIndex)
        }, 1500)
      },
    }
  });

  downstream__text__swiper.controller.control = downstream__center__swiper;




  let reachSec = document.querySelectorAll(".reachSec");


  reachSec.forEach(element => {
    element.addEventListener("click", function (e) {
      let slideIndex;
      setTimeout(() => {
        let id = window.location.hash;
        if (id) {
          downstream__text__swiper.slides.forEach((slide, i) => {
            if (slide.getAttribute('data-rid') == id.replace("#", "")) {
              slideIndex = i;
            }
          })
        }
        downstream__text__swiper.slideTo(slideIndex)
      }, 1000)
    });
  });






  let thumbSlider__for__Six = document.querySelector(".downstream-solution__thumb-slider");
  if (thumbSlider__for__Six.classList.contains("downstream-solution__thumb-slider--six")) {
    // console.log('what')
    thumbSlider__for__Six.closest(".downstream-solution__main-sliders-wrapper").classList.add("downstream-solution__main-sliders-wrapper--forsix");
  }


}

let avail = document.querySelector(".modal");

function Modal(modalMainWrapper, backdrop, show) {

  let modal = document.querySelector(modalMainWrapper),
    modal_backdrop = document.querySelector(backdrop),
    show_modal = document.querySelector(show);

  show_modal.addEventListener("click", function (e) {
    e.stopPropagation();
    modal.classList.add("show");
    modal_backdrop.classList.add("show");
  });

  document.addEventListener("click", function (e) {
    e.stopPropagation();
    if (e.target.closest(".modal")) {
      // console.log("modal")
      if (e.target.matches(".modal__cancel")) {
        // console.log(e.target.matches(".modal__cancel")  )
        modal.classList.remove("show");
        modal_backdrop.classList.remove("show");
      }
    } else {
      modal.classList.remove("show");
      modal_backdrop.classList.remove("show");
    }
  });

}

if (avail) {
  Modal(".modal", ".modal-backdrop", ".show-modal");
}


let innerLink = document.querySelectorAll('.js-inner')
innerLink.forEach(el => el.addEventListener('click', e => functionforscroll(e.target.getAttribute('data-id'))))

function functionforscroll(id) {
  var getMeTo = document.getElementById(id);
  setTimeout(function () {
    getMeTo.scrollIntoView();
  }, 100)
  var uri = window.location.toString();
  if (uri.indexOf("#") > 0) {
    var clean_uri = uri.substring(0, uri.indexOf("#"));
    window.history.replaceState({}, document.title, clean_uri);
  }
}

if (sw < 767) {
  var aa = document.querySelector(".emdad-briefImage");

  if (aa) {
    var element = document.createElement("right-mobileImg");
    var aaaaa = element.appendChild(aa);
    document.querySelector('.right-mobileImg1').appendChild(aaaaa);
  }

}